import { combineReducers } from "redux";

import { layoutsEasilReducers as easil } from "./layoutsEasilReducers";
import { layoutsTeamReducers as team } from "./layoutsTeamReducers";

export default combineReducers({
  easil,
  team
});
